<template>
  <div :class="rootClass" :style="rootStyle">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="error-page-content">
        <div class="error-page-content-lt">
          <JssRichText class="error-page-content-lt-title" :field="fields?.title" />
          <JssRichText class="error-page-content-lt-subtitle" :field="fields?.subtitle" />
          <JssRichText class="error-page-content-lt-desc" :field="fields?.desc" />
          <SiteButton v-bind="fields?.button" />
        </div>
        <div class="error-page-content-rt">
          <AdaptiveImage
            class="error-page-image"
            :field="fields?.image"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ErrorPage',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const state = reactive({
      expandedIndexes: [],
    });

    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'error-page'));

    const rootStyle = computed(() => {
      return utils.overall.baseComStyle(props.fields);
    });

    return {
      state,
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.error-page {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 32px;

    &-lt {
      &-title {
        font-size: 24px;
        font-weight: 700;
        line-height: 30px;
        margin-bottom: 16px;
        color: $blue-night;
      }

      &-subtitle {
        font-size: 20px;
        line-height: 1.2;
        margin-bottom: 12px;
        color: $grey-black;
      }

      &-desc {
        font-size: 14px;
        line-height: 1.4;
        color: #656565;
        margin-bottom: 24px;
      }
    }

    &-rt {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .error-page-image {
      width: 100%;
      max-width: 280px;
      height: auto;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 0;

      &-lt {
        width: grid-width(8.2);
        &-title {
          font-size: 90px;
          line-height: 1;
          margin-bottom: 16px;
        }

        &-subtitle {
          font-size: 40px;
          line-height: 1.2;
          margin-bottom: 16px;
        }

        &-desc {
          font-size: 16px;
          line-height: 1.4;
          margin-bottom: 40px;
        }
      }

      &-rt {
        width: grid-width(10.8);
      }

      .error-page-image {
        max-width: 100%;
      }
    }
  }
}
</style>
